function Adoptable(props) {
    return (
        <div className='adoptable'>
        <div id = 'adopt-details'>
          <p>click my eggs boy</p>
        </div>
        <div id = 'adopt-container'>
          <div className='little-guy'>
            <a href="https://dragcave.net/view/08mJV"><img src="https://dragcave.net/image/08mJV.gif" style={{borderWidth: 0, maxHeight:'40px'}} alt="Dragon Cave: Adopt one today!"/></a>
            <p>Gloopy</p>
            </div>
          <div className='little-guy'>
            <a href="https://finaloutpost.net/view/xjjg7/"><img src="https://finaloutpost.net/s/xjjg7.png" style={{borderWidth: 0, maxHeight:'40px'}} /></a>
            <p>Budesonide</p>
          </div>
        </div>
        <button id='hatchery-btn' onClick={()=>props.handlePages("hatchery")}>Feed more beasts</button>

      </div>
    );
  }

  export default Adoptable;